import React from "react";

function CompanyShipments() {
  return <h1>Shipment Records</h1>;
}

export default CompanyShipments;
